import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { helloWorld } from '../queries';

export const useHelloWorld = () => {
  const { entityRef } = useParams();

  return useQuery({
    queryKey: ['helloWorld', entityRef],
    queryFn: helloWorld.helloWorld,
  });
};

export const useUpdateHelloWorld = () => {
  const { entityRef } = useParams();
  const queryClient = useQueryClient();

  const queryKey = ['helloWorld', entityRef];

  const mutation = useMutation({
    mutationFn: helloWorld.updateHelloWorld,
    onMutate: async newItem => {
      await queryClient.cancelQueries(queryKey);
      const previousItem = queryClient.getQueryData(queryKey);
      const newData = previousItem?.map?.(item => (item.crn === newItem.crn ? newItem : item));
      queryClient.setQueryData(queryKey, newData);
      return { previousItem, newItem };
    },
    onError: (err, newItem, context) => {
      queryClient.setQueryData(queryKey, context.previousItem);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  return mutation.mutateAsync;
};
